import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import { Container, Dimmer, Header, Loader } from "semantic-ui-react";
import { Navigation } from "src/components/Navigation";
import { withAuthorization } from "../../components/Session/withAuthorization";

const DatasourcesTable = React.lazy(
  () => import(/* webpackChunkName: "Datasources" */ "./DatasourcesTable")
);

const DatasourcesComponent = ({
  authUser,
  orgId,
  history,
  location,
  match,
  usersStatus,
}: any) => (
  <React.Fragment>
    <Navigation />
    <Container className="main-container">
      <Header as="h2" className="page-title">
        Datasources
      </Header>
      <React.Suspense
        fallback={
          <Dimmer inverted={true}>
            <Loader size="small">Fetching data</Loader>
          </Dimmer>
        }
      >
        <DatasourcesTable
          authUser={authUser}
          location={location}
          orgId={orgId}
          history={history}
          usersStatus={usersStatus}
        />
      </React.Suspense>
    </Container>
  </React.Fragment>
);

const mapStateToProps = (state: any) => ({
  authUser: state.sessionState.authUser,
  orgId: state.sessionState.orgId,
  usersStatus: state.sessionState.usersStatus,
});

const authCondition = (authUser: any) => !!authUser;

const Datasources = compose(
  withAuthorization(authCondition),
  connect(mapStateToProps)
)(withRouter(DatasourcesComponent));

export default Datasources;



// WEBPACK FOOTER //
// ./src/containers/Datasources/index.tsx